import { AVIALABLE_LANG } from "@assets/languages/available-lang";
import { getToastStore } from "@utils/ToastStore";
import AppEnviroment from "app-enviroment";
import axios from "axios";

const gateway = axios.create({
  baseURL: AppEnviroment.getGatewayUrl(),
});

gateway.interceptors.request.use((config) => {
  // Prende la lingua dall'app nativa se presente, altrimenti dal browser se valida
  const currLang = localStorage.getItem('lang') || navigator.language?.substring(0, 2) || 'en';
  const validLang = AVIALABLE_LANG.includes(currLang) ? currLang : 'en';

  const params = new URLSearchParams(config.params || {});
  params.set('lang', validLang);
  config.params = params;
  return config;
});

gateway.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const ctx = getToastStore();   
        if (error.response) {
            if (ctx) {
                 const msg = error.response?.data?.error || error.message || "Errore generico";
                ctx.setToastMsg(msg);
                ctx.setSeeToast(true); 
                ctx.setErrorToast(true);
            }
            console.warn("Status:", error.response.status);
            console.log(error.response);
            console.warn("Data:", JSON.stringify(error.response.data, null, 2));
            throw new Error(error.response.data.error);
        } else {
            if (ctx) {
                ctx.setToastMsg(error.message || "Errore di rete");
                ctx.setSeeToast(true);
                ctx.setErrorToast(true);
            }
            console.warn("Errore generico:", error.message);
        }
    }
);

export default gateway;
